/**
 * 遊戲配置常數
 * 集中管理遊戲中的魔術數字和配置值，提高可維護性
 */
export const GameConfig = {
  // 遊戲尺寸
  WIDTH: 1280,
  HEIGHT: 800,

  // 生成機率
  SPAWN_CHANCE: 0.11,

  // 粒子效果配置
  SMOKE: {
    LIFECYCLE: 6000,
    PARTICLE_COUNT: 50,
    MIN_SCALE: 0.1,
    MAX_SCALE: 0.9,
    MIN_ROTATION: -5,
    MAX_ROTATION: 5,
    Y_SPEED_MIN: -5,
    Y_SPEED_MAX: -2,
    X_SPEED_MIN: 10,
    X_SPEED_MAX: 20,
    GRAVITY: -10,
    ALPHA_MAX: 0.2,
    EMIT_INTERVAL: 100
  },

  // 背景配置
  BACKGROUND: {
    WIDTH: 2000,
    HEIGHT: 1024,
    FADE_DURATION: 1000,
    SCROLL_SPEED: 0.5
  },

  // 蟑螂配置
  COCKROACH: {
    TYPES: ['cockroach-red', 'cockroach-green', 'cockroach-lbrown', 'cockroach-purple'],
    SPAWN_OFFSET_Y: 200,
    RESET_OFFSET_X: 100,
    RESET_RANDOM_X: 400,
    MIN_SCALE: 0.3,
    MOVE_SPEED_MULTIPLIER: 10
  },

  // 蜘蛛配置
  SPIDER: {
    SPAWN_INTERVAL: 2000, // 毫秒
    SPAWN_COUNT: 10,
    SPAWN_OFFSET_Y: 200
  },

  // 文字飛行動畫配置
  FLYING_TEXT: {
    START_X: -300,
    END_X: 1500,
    MIN_Y: 50,
    MAX_Y: 700,
    DURATION: 14000,
    INTERVAL: 2000, // 毫秒
    PADDING: 10 // 文字內邊距（像素）
  },

  // 死亡動畫配置
  DEATH_ANIMATION: {
    FADE_DURATION: 1000
  },

  // 音效索引
  SOUND_INDICES: {
    MAN_SCREAM_01: 0,
    MAN_SCREAM_02: 1,
    WOMAN_SCREAM_01: 2,
    WOMAN_SCREAM_02: 3
  }
};

